import { auth } from '@utils/auth';
import { http } from '@api/base-http';
import { RBACRole } from '../types/roles';

export const fetchRolesApi = <T>(
  organizationId: string = auth.getCurrentOrganizationId() as string,
) => {
  // This is a temporary fix to the broken roles page,
  // it will be changed when adapting the roles table to our DataTable component
  const params = {
    limit: 100,
    page_number: 1,
  };
  return http.get<T>(`/api/v1/organization/${organizationId}/roles`, { params });
};

export const createRoleApi = <T>(
  payload: RBACRole,
  organizationId: string = auth.getCurrentOrganizationId() as string,
) => {
  return http.post<T>(`/api/v1/organization/${organizationId}/roles`, payload);
};

export const updateRoleApi = <T>(
  payload: RBACRole,
  organizationId: string = auth.getCurrentOrganizationId() as string,
) => {
  const { role_id: roleId, ...rest } = payload;
  return http.put<T>(`/api/v1/organization/${organizationId}/roles/${roleId}`, rest);
};

export const deleteRoleApi = <T>(
  payload: RBACRole,
  organizationId: string = auth.getCurrentOrganizationId() as string,
) => {
  return http.delete<T>(`/api/v1/organization/${organizationId}/roles/${payload.role_id}`);
};
